import { ELocalStorageKeys } from './config'

export const isDev = process.env.NODE_ENV === 'development' || false

export const isJest = process.env.JEST_WORKER_ID !== undefined || false
export const isOpenResty = process.env.NEXT_PUBLIC_OPEN_RESTY === 'true' || false

// check if window exists and if Cypress is defined on it
export const isCypress = typeof window !== 'undefined' && 'Cypress' in window
export const isServer = typeof window === 'undefined'
export const isClient = typeof window !== 'undefined'
export const isTest = process.env.NODE_ENV === 'test' || false

// localStorage has priority over env var for local toggle of mock server
export const isMockServiceEnabled = (): boolean => {
  if (isTest || isJest || isOpenResty) {
    return false
  }

  if (isClient) {
    const localStorageValue = localStorage.getItem(ELocalStorageKeys.MOCK_SERVICE_ENABLED)
    const envValue = process.env.NEXT_PUBLIC_MSW_ENABLED === 'true'

    // Check localStorage first
    if (localStorageValue !== null) {
      return localStorageValue === 'true'
    }

    // If localStorage is not set, fall back to environment variable
    if (envValue !== undefined) {
      return envValue
    }
  }

  // If none are set, fall back to isDev
  return isDev
}

export const basePath = isOpenResty || !isDev ? '/profile/broadband/' : '/'

export const broadbandMainBaseURL = isOpenResty || !isDev ? '/broadband' : ''

// runtime environment keys
export enum Environments {
  DEVELOPMENT = 'dev',
  PRODUCTION = 'prd',
  STAGING = 'stg',
  TESTING = 'tst',
}

// All page routes
export enum EPageRoutes {
  CHANGE_INSTALL_DATES = '/profile/broadband/manage-order/change-install-dates/',
  HOME = '/',
  LOGIN = '/auth/login',
}

export enum EHttpMethods {
  DELETE = 'DELETE',
  GET = 'GET',
  PATCH = 'PATCH',
  POST = 'POST',
  PUT = 'PUT',
}

export enum EQueryKeys {
  AMENDMENT_PRODUCTS = 'amendmentProducts',
  CHANGE_PLAN_PREVIEW = 'changePlanPreview',
  CPE_ORDER = 'cpeOrder',
  ECOMMERCE_ORDER_SCHEDULE = 'ecommerceOrderSchedule',
  EVIDENCE_SESSION = 'evidenceSession',
  GENERATE_CONTRACT = 'generateContract',
  ORDER = 'order',
  PLAN = 'plan',
  PLAN_AMENDMENT_DETAILS = 'planAmendmentDetails',
  PLAN_BUYOUT_DETAILS = 'planBuyoutDetails',
  PRODUCTS = 'products',
  PROFILE = 'profile',
}

export enum OrderStateDetail {
  AMEND_REJECTED = 'AMEND_REJECTED',
  AMEND_REQUESTED = 'AMEND_REQUESTED',
  CANCELLATION_ACCEPTED = 'CANCELLATION_ACCEPTED',
  CANCELLATION_COMPLETED = 'CANCELLATION_COMPLETED',
  CANCELLATION_REJECTED = 'CANCELLATION_REJECTED',
  CANCELLATION_REQUESTED = 'CANCELLATION_REQUESTED',
  CANCELLED_BY_MEMBER = 'CANCELLED_BY_MEMBER',
  CANCELLED_BY_VM = 'CANCELLED_BY_VM',
  COMMITTED = 'COMMITTED',
  COMPLETED = 'COMPLETED',
  CONFIGURED = 'CONFIGURED',
  CREATED = 'CREATED',
  DELAYED = 'DELAYED',
  DELAYED_WITH_VM = 'DELAYED_WITH_VM',
  ENGINEER_ASSIGNED = 'ENGINEER_ASSIGNED',
  FAILED = 'FAILED',
  REJECTED = 'REJECTED',
  REQUESTED = 'REQUESTED',
  VALIDATED = 'VALIDATED',
  VISIT_ENDED = 'VISIT_ENDED',
  VISIT_STARTED = 'VISIT_STARTED',
}

export const CARD_BRAND_MAP: Record<string, string> = {
  AMERICAN_EXPRESS: 'Amex',
  MASTERCARD: 'Mastercard',
  VISA: 'Visa',
}
